import React from 'react';

const CurrencyItem = ({currency, switchCurrency, handleRequestClose}) => {
  const { code, rate } = currency;
  return (
    <li className="pointer" onClick={() => {
      handleRequestClose();
      switchCurrency(currency);
    }}>
      <div className="d-flex align-items-center">
        <h6 className="mb-0 ml-2">{code}</h6>
      </div>
    </li>
  );
};

export default CurrencyItem;
